import { getUpdatedDetailsReq } from "../../../../redux/specialist-slices/auth.slice";
import TabPanel from "../../../../components/common/TabPanel";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Professional from "./Professional";
import TrustSafety from "./TrustSafety";
import Expertise from "./Expertise";
import moment from "moment";

function Details() {
  const { userId } = useParams();
  const dispatch = useDispatch();
  const [data, setData] = useState({});
  const [value, setValue] = useState("expertise");
  const { refresh } = useSelector((state) => state.otherSlice);

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  // Handle retrieve specialist
  const handleGet = () => {
    dispatch(getUpdatedDetailsReq(userId))
      .unwrap()
      .then((data) => {
        setData(data);
      })
      .catch(() => { });
  };

  useEffect(() => {
    handleGet();
    // eslint-disable-next-line
  }, [refresh]);

  return (
    <Fragment>
      <Box>
        <Typography>
          <b>Email : </b>
          {data?.specialist?.email}
        </Typography>
        <Typography>
          <b>DOB : </b>
          {moment(data?.background?.dob).format("MM-DD-YYYY")}
        </Typography>
        <Typography>
          <b>Years of experience : </b>
          {data?.experties?.experience}
        </Typography>
      </Box>

      <Box sx={{ mt: 3, borderTop: "1px solid", borderColor: "divider" }}>
        <Tabs
          value={value}
          variant="scrollable"
          onChange={handleChange}
          sx={{ button: { fontFamily: "Poppins" } }}
        >
          <Tab label="User Expertise" value="expertise" />
          <Tab label="Trust & safety" value="trust-safety" />
          <Tab label="Professional profile" value="professional-profile" />
        </Tabs>
      </Box>

      <Box sx={{ pt: 3 }}>
        <TabPanel
          index={value}
          value="expertise"
          children={<Expertise expertise={data?.experties} />}
        />
        <TabPanel
          index={value}
          value="trust-safety"
          children={<TrustSafety specialist={data} />}
        />
        <TabPanel
          index={value}
          value="professional-profile"
          children={<Professional specialist={data} />}
        />
      </Box>
    </Fragment>
  );
}

export default Details;
